import React, { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import SearchTileStackInclusionsList from '../shared/SearchTileStackInclusionsList'
import ModalContext from 'contexts/ModalContext'
import Modal from 'LuxKit/Modal/Modal'
import OfferInclusionsList from 'components/Common/Inclusions/OfferInclusionsList'
import useOfferUrl from 'hooks/Offers/useOfferUrl'

interface Props {
  offer: App.BundleOffer
  offerMetaData?: App.OfferListMetaData
  filters?: App.OfferListFilters

}

function HotelBundleSearchTileFeatures({ offer, offerMetaData, filters }: Props) {
  const intl = useIntl()
  const offerUrl = useOfferUrl(offer, {
    filters,
    bundledOfferId: offerMetaData?.bundledOfferId,
    offerLinkIncludesFilters: true,
  })

  const showModal = useContext(ModalContext)
  const openInclusionsModal = useCallback(() => {
    showModal(<Modal
      title=""
      primaryActionText={intl.formatMessage({
        id: 'fE5GIl6sB5ywqYZgR8Lf',
        defaultMessage: 'View offer',
        description: 'CTA button in hotel bundle inclusions modal to view the offer',
      })}
      primaryActionTo={offerUrl}
    >
      <OfferInclusionsList inclusions={offer.tileInclusions!} />
    </Modal>)
  }, [offer, offerUrl, showModal, intl])

  if (!offer.tileInclusions?.length) return null

  return <SearchTileStackInclusionsList
    inclusions={offer.tileInclusions}
    inclusionsTitle={offer.tileInclusionsHeading}
    onShowMoreClick={openInclusionsModal}
  />
}

export default HotelBundleSearchTileFeatures
